module.exports = __webpack_public_path__ + "media/assets_v3/images/sign-box-envelope-784f28c8a2fd0571d02db8bbde4f7e40.png";